export default __webpack_public_path__ + "static/media/engineer.808c6349.svg";